import type { TrainingCondition } from "@lemmonhq/knowledgebase";
import {
  predicateRegistry as defaultRegistry,
  type PredicateRegistry,
  type TrainingContext,
  type TrainingPredicate,
} from "./predicates";

function callPredicate(fn: TrainingPredicate, ctx: TrainingContext, args: (string | number | boolean)[]): boolean {
  try {
    return fn(ctx, ...args);
  } catch (err) {
    console.warn("[training] predicate threw", err);
    return false;
  }
}

export function evaluateCondition(
  condition: TrainingCondition | undefined,
  ctx: TrainingContext,
  registry: PredicateRegistry = defaultRegistry,
): boolean {
  if (condition === undefined) return true;

  if (typeof condition === "string") {
    const fn = registry[condition];
    if (!fn) {
      if (import.meta.env?.DEV) {
        console.warn(`[training] unknown predicate '${condition}'`);
      }
      return false;
    }
    return callPredicate(fn, ctx, []);
  }
  if ("all" in condition) {
    return condition.all.every((c) => evaluateCondition(c, ctx, registry));
  }
  if ("any" in condition) {
    return condition.any.some((c) => evaluateCondition(c, ctx, registry));
  }
  if ("not" in condition) {
    return !evaluateCondition(condition.not, ctx, registry);
  }
  const fn = registry[condition.predicate];
  if (!fn) {
    if (import.meta.env?.DEV) {
      console.warn(`[training] unknown predicate '${condition.predicate}'`);
    }
    return false;
  }
  return callPredicate(fn, ctx, condition.args ?? []);
}
